import script from "./AccordionDetailsComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./AccordionDetailsComponent.vue?vue&type=script&setup=true&lang=js"

import "./AccordionDetailsComponent.vue?vue&type=style&index=0&id=64e8bc50&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64e8bc50"]])

export default __exports__